import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useContext } from 'react';
export function useSize(defaultWidth, defaultHeight, alignment, containerSize) {
    const isMobile = useContext(MobileContext);
    containerSize = containerSize !== null && containerSize !== void 0 ? containerSize : Infinity;
    let width = defaultWidth;
    let height = defaultHeight;
    const ratio = width / height;
    if (alignment !== 'center') {
        width = Math.min(defaultWidth / 2, +defaultWidth);
        if (defaultWidth > containerSize) {
            width = Math.min(containerSize / 2, +defaultWidth);
        }
        height = width / ratio;
    }
    // Keep within bounds
    if (width > containerSize) {
        width = containerSize;
        if (isMobile) {
            width = width - 32;
        }
        height = width / ratio;
    }
    return {
        width,
        height
    };
}

//# sourceMappingURL=useSize.js.map